/**
 * household.ts
 * [Readme] --------------------------------------------------------------------------------------
 * 
 * 세대 탭에서 사용하는 데이터의 모음입니다.
 * 일부 데이터는 직접 세대 페이지 컴포넌트에 넣는 경우도 존재합니다.
 * 
 * -----------------------------------------------------------------------------------------------
 */

import img1_1 from 'assets/Desktop/images/parcelOut/planimages_63a.png';
import img2_1 from 'assets/Desktop/images/parcelOut/pyposition_63a.png';
import img2_1_big from 'assets/Desktop/images/parcelOut/pyposition_63a_big.png';
import img3_1 from 'assets/Desktop/images/parcelOut/groundplan_d_63a.png';
import img4_1 from 'assets/Desktop/images/parcelOut/groundplan_s_63a.png';
import img5_1 from 'assets/Desktop/images/parcelOut/interior_01_01.jpg';
import img5_1_big from 'assets/Desktop/images/parcelOut/interior_01_01_big.jpg';

import img1_2 from 'assets/Desktop/images/parcelOut/planimages_63b.png';
import img2_2 from 'assets/Desktop/images/parcelOut/pyposition_63b.png';
import img2_2_big from 'assets/Desktop/images/parcelOut/pyposition_63b_big.png';
import img3_2 from 'assets/Desktop/images/parcelOut/groundplan_d_63b.png';
import img4_2 from 'assets/Desktop/images/parcelOut/groundplan_s_63b.png';

import img1_3 from 'assets/Desktop/images/parcelOut/planimages_84a.png';
import img2_3 from 'assets/Desktop/images/parcelOut/pyposition_84a.png';
import img2_3_big from 'assets/Desktop/images/parcelOut/pyposition_84a_big.png';
import img3_3 from 'assets/Desktop/images/parcelOut/groundplan_d_84a.png';
import img4_3 from 'assets/Desktop/images/parcelOut/groundplan_s_84a.png';

import img1_4 from 'assets/Desktop/images/parcelOut/planimages_84b.png';
import img2_4 from 'assets/Desktop/images/parcelOut/pyposition_84b.png';
import img2_4_big from 'assets/Desktop/images/parcelOut/pyposition_84b_big.png';
import img3_4 from 'assets/Desktop/images/parcelOut/groundplan_d_84b.png';
import img4_4 from 'assets/Desktop/images/parcelOut/groundplan_s_84b.png';

import img1_5 from 'assets/Desktop/images/parcelOut/planimages_116.png';
import img2_5 from 'assets/Desktop/images/parcelOut/pyposition_116.png';
import img2_5_big from 'assets/Desktop/images/parcelOut/pyposition_116_big.png';
import img3_5 from 'assets/Desktop/images/parcelOut/groundplan_d_116.png';
import img4_5 from 'assets/Desktop/images/parcelOut/groundplan_s_116.png';

import pdf1 from 'assets/common/230331_finishlist.pdf';
// import pdf2 from 'assets/common/221091_squremeasure.pdf';

/**
 * 평방미터를 평형으로 계산하기 위한 기본 고정 값입니다.
 * 평방미터 * CAL_FEET 하여 처리하며 Math.floor(평방미터 * CAL_FEET)를 하여 소수점을 없앱니다.
 * 아파트는 공급면적, 오피스텔은 계약면적 기준
 */
const CAL_FEET: number = 0.3025;

/**
 * 세대 탭의 평면 정보 메뉴에서 사용하는 데이터 목록
 */
export const listContent = [
  {
    id: 1,
    img1: img1_1,
    img2: img2_1,
    img2_big: img2_1_big,
    img3: img3_1,
    img4: img4_1,
    tit: '63㎡A형',
    tit2: `${Math.floor(83.1770 * CAL_FEET)}평A형`,
    subtit: '총 123세대 중 일반분양 98세대',
    subtit2: '실별 짜임새 있는 공간 구성과 맞통풍 설계로 환기와 채광이 우수한 판상형 구조',
    titcontent1: '평면타입',
    titcontent2: '단지 배치도',
    titcontent3: '비확장',
    titcontent4: '발코니 확장+추가선택품목',
    residential_area: '63.9992㎡',          // 전용 면적
    common_residential_area: '19.1778㎡',   // 공용 면적
    supply_area: '83.1770㎡',               // 공급 면적
    other_common_areas: '44.3271㎡',        // 기타 공용면적
    // underground_parking_lot: '61.8516㎡',   // 지하주차장
    contract_area: '127.5041㎡',            // 계약 면적
    footer: true,
    swiper: [
      {
        img: img3_1,
        title: '비확장'
      },
      {
        img: img4_1,
        title: '발코니 확장+추가선택품목'
      }
    ],
    addInfo: `
      ①현관 중문  ②현관 오픈형신발장 ③침실2 붙박이장  ④침실1 화장대+붙박이장+의류관리기  ⑤주방 엔지니어드스톤 마감 ⑥거실 세라믹패널 아트월\n
      ⑦거실 디자인패널 마감 ⑧거실 우물천장 직간접 조명 ⑨하이브리드 쿡탑/인덕션 ⑩욕실 복합 환풍기 ⑪비데일체형 양변기 ⑫전동빨래건조대\n
      \n※ 천장형 시스템에어컨 및 빌트인 가전제품, 와이드 강마루 및 침실 색온도 디밍 시스템은 별도 확인 바랍니다.
      \n※ 추가선택품목 관련 자세한 사항은 입주자모집공고를 참조하시기 바랍니다.
    `,
    interiorDisplay : true,
    interiorSwiper : [
      {
        img: img5_1,
        title: '거실',
        img_big: img5_1_big
      },
      {
        img: img5_1,
        title: '주방',
        img_big: img5_1_big
      },
      {
        img: img5_1,
        title: '욕실1',
        img_big: img5_1_big
      },
      {
        img: img5_1,
        title: '욕실2',
        img_big: img5_1_big
      },
      {
        img: img5_1,
        title: '침실1',
        img_big: img5_1_big
      }
    ]
  },
  {
    id: 2,
    img1: img1_2,
    img2: img2_2,
    img2_big: img2_2_big,
    img3: img3_2,
    img4: img4_2,
    tit: '63㎡B형',
    tit2: `${Math.floor(83.4923 * CAL_FEET)}평B형`,
    subtit: '총 14세대 중 일반분양 14세대',
    subtit2: '공간별 프라이버시가 확보되는 평면으로 열린 거실과 오픈형 주방을 갖춘 탑상형 구조',
    titcontent1: '평면타입',
    titcontent2: '단지 배치도',
    titcontent3: '비확장',
    titcontent4: '발코니 확장+추가선택품목',
    residential_area: '63.9957㎡',          // 주거 전용 면적
    common_residential_area: '19.4966㎡',   // 주거 공용 면적
    supply_area: '83.4923㎡',              // 공급 면적
    other_common_areas: '44.3247㎡',        // 기타 공용면적
    // underground_parking_lot: '61.8516㎡',   // 지하주차장
    contract_area: '127.8170㎡',            // 계약 면적
    footer: true,
    swiper: [
      {
        img: img3_2,
        title: '비확장'
      },
      {
        img: img4_2,
        title: '발코니 확장+추가선택품목'
      }
    ],
    addInfo: `
    ①현관 중문  ②현관 오픈형신발장 ③침실2 붙박이장  ④침실1 화장대+붙박이장+의류관리기+벽패널마감  ⑤주방 엔지니어드스톤 마감\n
    ⑥거실 세라믹패널 아트월 ⑦거실 디자인패널 마감 ⑧거실 우물천장 직간접 조명 ⑨하이브리드 쿡탑/인덕션 ⑩욕실 복합 환풍기 ⑪비데일체형 양변기\n
    ⑫전동빨래건조대 ⑬주방아일랜드장
      \n※ 천장형 시스템에어컨 및 빌트인 가전제품, 와이드 강마루 및 침실 색온도 디밍 시스템은 별도 확인 바랍니다.
      \n※ 추가선택품목 관련 자세한 사항은 입주자모집공고를 참조하시기 바랍니다. 
    `,
    interiorDisplay : false,
    interiorSwiper : [
      {
        img: img5_1,
        title: '거실',
        img_big: img5_1_big
      }
    ]
  },
  {
    id: 3,
    img1: img1_3,
    img2: img2_3,
    img2_big: img2_3_big,
    img3: img3_3,
    img4: img4_3,
    tit: '84㎡A형',
    tit2: `${Math.floor(110.2444 * CAL_FEET)}평A형`,
    subtit: '총 278세대 중 일반분양 38세대',
    subtit2: '우수한 개방감과 여유로운 공간구성, 주방 원스톱 세탁실 등을 갖춰 생활의 편리함을 극대화한 판상형 구조',
    titcontent1: '평면타입',
    titcontent2: '단지 배치도',
    titcontent3: '비확장',
    titcontent4: '발코니 확장+추가선택품목',
    residential_area: '84.9995㎡',          // 주거 전용 면적
    common_residential_area: '25.2449㎡',   // 주거 공용 면적
    supply_area: '110.2444㎡',              // 공급 면적
    other_common_areas: '58.8725㎡',        // 기타 공용면적
    // underground_parking_lot: '62.0368㎡',   // 지하주차장
    contract_area: '169.1169㎡',            // 계약 면적
    footer: true,
    swiper: [
      {
        img: img3_3,
        title: '비확장'
      },
      {
        img: img4_3,
        title: '발코니 확장+추가선택품목'
      }
    ],
    addInfo: `
    ①현관 중문  ②현관 오픈형신발장 ③침실2 붙박이장  ④침실1 화장대+붙박이장+의류관리기+오픈형선반장+벽패널마감   ⑤주방 엔지니어드스톤 마감\n
    ⑥거실 세라믹패널 아트월 ⑦거실 디자인패널 마감 ⑧세대 공용공간 고급화 마감 ⑨거실 우물천장 직간접 조명 ⑩하이브리드 쿡탑/인덕션\n
    ⑪욕실 복합 환풍기 ⑫비데일체형 양변기 ⑬전동빨래건조대 ⑭주방아일랜드장 ⑮손빨래하부장
      \n※ 천장형 시스템에어컨 및 빌트인 가전제품, 와이드 강마루 및 침실 색온도 디밍 시스템은 별도 확인 바랍니다.
      \n※ 추가선택품목 관련 자세한 사항은 입주자모집공고를 참조하시기 바랍니다. 
    `,
    interiorDisplay : true,
    interiorSwiper : [
      {
        img: img5_1,
        title: '거실',
        img_big: img5_1_big
      },
      {
        img: img5_1,
        title: '거실',
        img_big: img5_1_big
      },
      {
        img: img5_1,
        title: '거실',
        img_big: img5_1_big
      },
      {
        img: img5_1,
        title: '거실',
        img_big: img5_1_big
      },
      {
        img: img5_1,
        title: '거실',
        img_big: img5_1_big
      }
    ]
  },
  {
    id: 4,
    img1: img1_4,
    img2: img2_4,
    img2_big: img2_4_big,
    img3: img3_4,
    img4: img4_4,
    tit: '84㎡B형',
    tit2: `${Math.floor(110.0136 * CAL_FEET)}평B형`,
    subtit: '총 127세대중 일반분양 26세대',
    subtit2: '부부공간과 자녀공간을 분리하여 공간별 프라이버시가 확보되고, 열린 거실과 오픈형 주방을 갖춘 탑상형 구조',
    titcontent1: '평면타입',
    titcontent2: '단지 배치도',
    titcontent3: '비확장',
    titcontent4: '발코니 확장+추가선택품목',
    residential_area: '84.9925㎡',         // 주거 전용 면적
    common_residential_area: '25.0211㎡',   // 주거 공용 면적
    supply_area: '110.0136㎡',              // 공급 면적
    other_common_areas: '58.8676㎡',        // 기타 공용면적
    // underground_parking_lot: '61.8524㎡',   // 지하주차장
    contract_area: '168.8812㎡',            // 계약 면적
    footer: true,
    swiper: [
      {
        img: img3_4,
        title: '비확장'
      },
      {
        img: img4_4,
        title: '발코니 확장+추가선택품목'
      }
    ],
    addInfo: `
    ①현관 중문  ②현관 오픈형신발장 ③침실2 붙박이장  ④침실1 화장대+붙박이장+의류관리기+벽패널마감   ⑤주방 엔지니어드스톤 마감\n
    ⑥거실 세라믹패널 아트월 ⑦거실 디자인패널 마감 ⑧세대 공용공간 고급화 마감 ⑨거실 우물천장 직간접 조명 ⑩하이브리드 쿡탑/인덕션\n
    ⑪욕실 복합 환풍기 ⑫비데일체형 양변기 ⑬전동빨래건조대 ⑭주방아일랜드장 ⑮손빨래하부장
      \n※ 천장형 시스템에어컨 및 빌트인 가전제품, 와이드 강마루 및 침실 색온도 디밍 시스템은 별도 확인 바랍니다.
      \n※ 추가선택품목 관련 자세한 사항은 입주자모집공고를 참조하시기 바랍니다. 
    `,
    interiorDisplay : false,
    interiorSwiper : [
      {
        img: img5_1,
        title: '거실',
        img_big: img5_1_big
      }
    ]
  }
];

/**
 * 파일 목록
 */
export const listContentFile = [
  {
    title: '마감재리스트 확인',
    file: pdf1
  },
  // {
  //   title: '주택형별 면적 확인',
  //   file: pdf2
  // }
]
